import { render, staticRenderFns } from "./ViewEmployeeLeaves.vue?vue&type=template&id=7a865bc2&"
import script from "./ViewEmployeeLeaves.vue?vue&type=script&lang=ts&"
export * from "./ViewEmployeeLeaves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports